<template>
  <div>
    <form class="w-50 mx-auto text-start">
      <div class="botonVaciar">
        <button @click.prevent="cleanFields()" type="reset" class="btn btn-light">
          Vaciar campos
        </button>
      </div>
      <br />
      <div class="mb-3">
        <label for="username" class="form-label">Nombre de usuario:</label>
        <input type="text" class="form-control" id="username" v-model="username" />
      </div>
      <label for="password" class="form-label">Contraseña:</label>
      <div class="input-group mb-3">
        <input class="form-control" id="password" v-model="password" :type="showPassword ? 'text' : 'password'" />
        <span class="input-group-text" id="basic-addon2">
          <svg v-show="hidePassIcon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
            class="bi bi-eye-slash-fill mt-1" viewBox="0 0 16 16" :class="{ 'bi-eye-slash': !showPassword }"
            @click="togglePasswordVisibility">
            <path
              d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7 7 0 0 0 2.79-.588M5.21 3.088A7 7 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474z" />
            <path
              d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12z" />
          </svg>
          <svg v-show="showPassIcon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
            class="bi bi-eye-fill mt-1" viewBox="0 0 16 16" :class="{ 'bi-eye-slash': showPassword }"
            @click="togglePasswordVisibility2">
            <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
            <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
          </svg>
        </span>
      </div>
    </form>
    <button type="submit" class="btn btn-danger" @click.prevent="login">
      Ingresar
    </button>
    <div class="container w-50 mt-3 mx-auto">
      <hr />
      <table class="mx-auto">
        <tbody>
          <tr>
            <td>
              <label for="registerUser">¿No tiene usuario?, Registre su información aquí...</label>
            </td>
            <td>
              <router-link to="/RegisterUser" class="btn btn-light ms-3 disabled">
                Registrar nuevo usuario
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>
      <hr />
    </div>
  </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
export default {
  data() {
    return {
      showPassword: false,
      hidePassIcon: true,
      showPassIcon: false,
      username: "",
      password: "",
      userRoles: [],
      url: "",
    };
  },
  methods: {
    async login() {
      if (this.username === "" || this.password === "") {
        alert("Complete los campos requeridos para iniciar sesión el sistema.")
      } else {
        let formData = new FormData();
        formData.append("username", this.username);
        formData.append("password", this.password);
        try {
          let res = await axios.post(
            RUTA_SERVIDOR + "api/login",
            formData,
            { headers: { "Content-Type": "multipart/form-data" } }
          );
          console.log(res.data);
          if (!res.data) {
            console.log("There has been a different error with the data.");
          } else {
            const allowedRoles = ["ROLE_ADMIN", "ROLE_SELLER"];
            //console.log(res.data['token']);
            localStorage.setItem("token", res.data["token"]);
            //console.log(localStorage.getItem("token"));
            const userRoles = res.data["user"].roles;

            if (userRoles.some(role => allowedRoles.includes(role))) {
              // El usuario tiene al menos uno de los roles permitidos
              if (userRoles.includes("ROLE_ADMIN")) {
                this.$router.push("/Admin/Home");
              } else {
                this.$router.push("/Families");
              }
            } else {
              // El usuario no tiene los roles permitidos
              console.log("El usuario no tiene los roles permitidos.");
              // Puedes redirigir a una página de error o mostrar un mensaje al usuario.
            }
          }
        } catch (err) {
          if (err.response.status === 401) {
            //console.error("Error de autenticación: Usuario o contraseña incorrectos");
            // Puedes mostrar un mensaje al usuario indicando que las credenciales son incorrectas
            alert("Usuario o contraseña incorrectos. Por favor, inténtelo de nuevo.");
            this.cleanFields();
          } else {
            //console.error("Error durante el inicio de sesión:", err.message);
            // Puedes mostrar un mensaje genérico al usuario indicando que ha ocurrido un error
            alert("Error durante el inicio de sesión. Por favor, inténtelo de nuevo.");
          }
        }
      }
    },
    cleanFields() {
      this.username = "";
      this.password = "";
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
      this.showPassIcon = true;
      this.hidePassIcon = false;
    },
    togglePasswordVisibility2() {
      this.showPassword = false;
      this.showPassIcon = false;
      this.hidePassIcon = true;
    },
  },
};
</script>
<style scoped>
.botonVaciar {
  float: right !important;
}

.link1 {
  color: rgb(254, 254, 254);
}

@media screen and (max-width: 500px) {
  form {
    width: 100% !important;
  }

  .container {
    width: 100% !important;
  }
}
</style>